import { useState, useEffect, useRef } from 'react';
import Bredcrum from '../../components/bredcrum';
import { Tag } from 'primereact/tag';
import { Tablescom } from '../../components/tablescomp';
import { manufacturerServices } from '../../services/manufacturerServices';
import { Titlebar, Searchbox, Confirmdelete } from '../../components/fieldsComp';
import { BrowserRouter, Routes, Route, useNavigate } from "react-router";
import { Dialog } from 'primereact/dialog';
import { localurl } from '../../constant';
import { convertFileToBase64 } from '../../helpers/base64conversion';
import { Toast } from "primereact/toast";
import { profileservices } from '../../services/profileServices';
import { FaTrash, FaPlus } from "react-icons/fa"; // Optional: for better UX
import { useSelector } from 'react-redux';


const CompanyProfile = () => {
  const toast = useRef(null);
  const [userId, setUserId] = useState([]);
  const [profilelist, setProfilelist] = useState([]);
  const [loading, setLoading] = useState(false);
  const [logodata, setLogodata] = useState(null);
  const [currencies,setCurrencies] = useState([]);
  const currencyreducer = useSelector((state)=>state.currencyreducer);

  const companydata = JSON.parse(localStorage.getItem('companydata'));
  const logo = JSON.parse(localStorage.getItem('logo'));
  const [formData, setFormData] = useState({
    user_id: '',
    company_name: '',
    email: '',
    phone: '',
    website: '',
    postalcode:'',
    shipping: [
      {
        line: '',
        city: '',
        state: '',
        country: '',
      },
    ],
    address: '',
    city: '',
    state: '',
    country: '',
    logo: null,
  });


  const handleAddressChange = (index, field, value) => {
    const updatedAddresses = [...formData.shipping];
    updatedAddresses[index][field] = value;
    setFormData({ ...formData, shipping: updatedAddresses });
  };


  const addAddressField = () => {
    console.log("form data");
    console.log(formData);
    setFormData({
      ...formData,
      shipping: [
        ...formData.shipping,
        { line: '', city: '', state: '', country: '' },
      ],
    });
  };


  const removeAddressField = (index) => {
    if (formData.shipping.length === 1) return;
    const updatedAddresses = formData.shipping.filter((_, i) => i !== index);
    setFormData({ ...formData, shipping: updatedAddresses });
  };

 const handleChange = (e) => {
    const { name, value, files } = e.target;
    if (name === 'logo') {
      setFormData({ ...formData, logo: files[0] });
    } else {
      setFormData({ ...formData, [name]: value });
    }
  };

  const handleSubmit = (e) => {
    // e.preventDefault();
    let data = new FormData();
    setLoading(true);
    for (let key in formData) {
      if (key === "shipping") {
        data.append('shipping', JSON.stringify(formData.shipping)); // ✅ send as JSON string
      } else {
        data.append(key, formData[key]);
      }
    }
    // console.log("Update profile");
    // console.log(formData);
    // return;

    profileservices.updateprofile(data).then((response) => {
      setLoading(false);
      if (response.status === 200) {
        getprofile();
        toast.current.show({ severity: 'success', summary: 'Profile', detail: 'Company created successfully' });
      } else {
        toast.current.show({ severity: 'error', summary: 'Profile', detail: `${response.data.data}` });
      }
    }).catch((error) => {
      setLoading(false);
      toast.current.show({ severity: 'error', summary: 'Profile', detail: 'Error' });
    });
  };


  const getprofile = () => {
    profileservices.getprofile().then((response) => {
      if (response.status === 200) {
        const company = response.data.data;
        const logo = response.data.logo;

        const formattedCompany = {
          ...company,
          shipping: (() => {
            if (Array.isArray(company.shipping)) {
              if (typeof company.shipping[0] === 'object') return company.shipping;
              return company.shipping.map((addr) => ({
                line: addr,
                city: '',
                state: '',
                country: ''
              }));
            } else if (typeof company.shipping === "string") {
              try {
                const parsed = JSON.parse(company.shipping);
                if (Array.isArray(parsed)) {
                  return parsed.map((addr) =>
                    typeof addr === "string"
                      ? { line: addr, city: '', state: '', country: '' }
                      : addr
                  );
                }
                return [{ line: company.shipping, city: '', state: '', country: '' }];
              } catch {
                return company.shipping
                  .split("\n")
                  .map((line) => ({ line, city: '', state: '', country: '' }));
              }
            } else {
              return [{ line: '', city: '', state: '', country: '' }];
            }
          })(),
        };

        // Set state
        setFormData((prev) => ({
          ...prev,
          ...formattedCompany,
        }));

        setLogodata(logo);

        // Save to localStorage
        localStorage.setItem('companydata', JSON.stringify(formattedCompany));
        localStorage.setItem('logo', JSON.stringify(logo));
      }
    });
  };


  useEffect(() => {
    getprofile();
    getcurrency();
  }, []);

  const getcurrency = () => {
    currencyreducer.then((response)=>{
        setCurrencies(response);
      }).catch((error)=>{
    });
   } 

  const displayCurrency = () => {
    let items = [];
    currencies.forEach((value,index)=>{
      //  console.log(value); 
      //  console.log("display currency"); 
       items.push(<option key={index} value={value.code}>{value.name}</option>);
    })  
    return items;
  }


  return (
    <>
      <Toast ref={toast} />
      <Bredcrum title={'Profile'} divider={false} />
      <div class="row">
        {/* <Titlebar text={'Company Profile'} /> */}
        <div className="col-md-12 mt-2"></div>
      </div>

      
        <ul className="nav nav-tabs" role="tablist">
          {["Profile", "Contact", "Shipping","currency"].map((tab, idx) => (
            <li className="nav-item" key={idx} role="presentation">
              <button
                className={`nav-link ${idx === 0 ? "active" : ""}`}
                id={`${tab.toLowerCase()}-tab`}
                data-bs-toggle="tab"
                data-bs-target={`#${tab.toLowerCase()}`}
                type="button"
                role="tab"
                aria-controls={tab.toLowerCase()}
                aria-selected={idx === 0 ? "true" : "false"}
              >
                {tab}
              </button>
            </li>
          ))}
        </ul>

        <div className="tab-content border-start border-end border-bottom rounded-bottom p-4 bg-white">
          {/* --- PROFILE TAB --- */}
          <div className="tab-pane fade show active" id="profile" role="tabpanel">
            <h5 className="mb-4 fw-bold">Company Profile</h5>
            <div className="row g-3">
              <div className="col-md-6">
                <label className="form-label">Company Name</label>
                <input type="text" className="form-control" name="company_name" value={formData.company_name} onChange={handleChange} />
              </div>
              <div className="col-md-6">
                <label className="form-label">Email</label>
                <input type="email" className="form-control" name="email" value={formData.email} onChange={handleChange} />
              </div>
              <div className="col-md-6">
                <label className="form-label">Phone</label>
                <input type="text" className="form-control" name="phone" value={formData.phone} onChange={handleChange} />
              </div>
              <div className="col-md-6">
                <label className="form-label">Postal Code</label>
                <input type="number" className="form-control" name="postalcode" value={formData.postalcode} onChange={handleChange} />
              </div>
              <div className="col-md-6">
                <label className="form-label">Website</label>
                <input type="text" className="form-control" name="website" value={formData.website} onChange={handleChange} />
              </div>
              {logodata && (
                <div className="col-md-12 text-center mt-4">
                  <label className="form-label fw-semibold d-block">Current Logo</label>
                  <img src={logodata} alt="Logo" style={{ height: 100 }} className="img-fluid border rounded shadow-sm" />
                </div>
              )}
              <div className="col-md-12">
                <label className="form-label">Upload New Logo &nbsp;<small className="text-muted pt-10 text-warning">(Accepted formats: JPG, PNG. Max 2MB.)</small></label>
                <input type="file" className="form-control" name="logo" accept="image/*" onChange={handleChange} />
                
              </div>
            </div>
          </div>

          {/* --- CONTACT TAB --- */}
          <div className="tab-pane fade" id="contact" role="tabpanel">
            <h5 className="mb-4 fw-bold">Contact Details</h5>
            <div className="row g-3">
              <div className="col-md-12">
                <label className="form-label">Address</label>
                <textarea className="form-control" name="address" rows={2} value={formData.address} onChange={handleChange} />
              </div>
              <div className="col-md-4">
                <label className="form-label">City</label>
                <input type="text" className="form-control" name="city" value={formData.city} onChange={handleChange} />
              </div>
              <div className="col-md-4">
                <label className="form-label">State</label>
                <input type="text" className="form-control" name="state" value={formData.state} onChange={handleChange} />
              </div>
              <div className="col-md-4">
                <label className="form-label">Country</label>
                <input type="text" className="form-control" name="country" value={formData.country} onChange={handleChange} />
              </div>
            </div>
          </div>

          {/* --- SHIPPING TAB --- */}
          <div className="tab-pane fade" id="shipping" role="tabpanel">
            <h5 className="mb-4 fw-bold">Shipping Addresses</h5>
            {formData.shipping.map((addr, index) => (
              <div key={index} className="border rounded p-3 mb-3">
                <div className="row g-3">
                  <div className="col-md-10">
                    <label className="form-label">Address Line</label>
                    <textarea className="form-control" rows={2} value={addr.line} onChange={(e) => handleAddressChange(index, "line", e.target.value)} />
                  </div>
                  <div className="col-md-2 d-flex align-items-end">
                    {formData.shipping.length > 1 && (
                      <button type="button" className="btn btn-outline-danger w-100" onClick={() => removeAddressField(index)}>
                        <FaTrash className="me-1" /> Remove
                      </button>
                    )}
                  </div>
                  <div className="col-md-4">
                    <label className="form-label">City</label>
                    <input type="text" className="form-control" value={addr.city} onChange={(e) => handleAddressChange(index, "city", e.target.value)} />
                  </div>
                  <div className="col-md-4">
                    <label className="form-label">State</label>
                    <input type="text" className="form-control" value={addr.state} onChange={(e) => handleAddressChange(index, "state", e.target.value)} />
                  </div>
                  <div className="col-md-4">
                    <label className="form-label">Country</label>
                    <input type="text" className="form-control" value={addr.country} onChange={(e) => handleAddressChange(index, "country", e.target.value)} />
                  </div>
                </div>
              </div>
            ))}

            <button type="button" className="btn btn-outline-primary" onClick={addAddressField}>
              <FaPlus className="me-2" /> Add Shipping Address
            </button>
          </div>


          {/* --- Currency selection TAB --- */}  
          <div className="tab-pane fade" id="currency" role="tabpanel">
            <h5 className="mb-4 fw-bold"></h5>
               <div className="col-md-12">
                <label className="form-label">Default Trading Currency</label>
                 <select className="form-control" value={formData.default_currency} name="default_currency" style={{width:'180px'}} onChange={handleChange}>
                    {displayCurrency()}
                </select>
              </div>
          </div>

          {/* --- SUBMIT BUTTON --- */}

          <div className="mt-4 row" >
            <div class="col-md-6">
              <button type="button" onClick={() => handleSubmit()} class="btn color-white me-2 w-100 rounded custom-btn-br-color custom-btn-color" disabled={loading}>
                {loading ? (
                  <>
                    <span className="spinner-border spinner-border-sm me-2" role="status" />
                    Saving...
                  </>
                ) : (
                  "Save"
                )}
              </button>
            </div>
            <div class="col-md-6">
              <button type="button" class="btn color-white w-100 rounded custom-btn-color-secondary">Close</button></div></div>

        </div>
      

    </>
  );
}
export default CompanyProfile;